export default __webpack_public_path__ + "static/media/IMG_5341.8d977ed0.WEBP";